// Free-tool pages (under /tools). Same auto-registration pattern as resources.
// Each module exports a tool object:
//   { slug, name, title, metaTitle?, description, status: "coming-soon"|"live",
//     tldr, blocks, faqs?, related?, primaryCtaPath? }

/**
 * @typedef {Object} ToolContent
 * @property {string} slug
 * @property {string} name
 * @property {string} title
 * @property {string} description
 * @property {"coming-soon" | "live"} status
 * @property {string} tldr
 * @property {string} [metaTitle]
 * @property {import("../richText").RichBlock[]} blocks
 * @property {{question: string, answer: import("../richText").RichBlock[]}[]} [faqs]
 * @property {string[]} [related]
 * @property {string} [primaryCtaPath]
 */
/** @typedef {{default: ToolContent}} ToolModule */
/** @typedef {((key: string) => ToolModule) & {keys: () => string[]}} WebpackContext */
/**
 * @typedef {NodeRequire & {context: (directory: string, useSubdirectories: boolean, regExp: RegExp) => WebpackContext}} WebpackRequire
 */

const webpackRequire = /** @type {WebpackRequire} */ (require);
const ctx = webpackRequire.context("./items", false, /\.js$/);

export const tools = ctx
  .keys()
  .map((key) => ctx(key).default)
  .filter(Boolean);

export const toolsBySlug = tools.reduce(
  (acc, t) => {
    acc[t.slug] = t;
    return acc;
  },
  /** @type {Record<string, ToolContent>} */ ({})
);

/** @param {string} slug */
export const getTool = (slug) => toolsBySlug[slug] || null;
